import { keepTwoOrLine } from '@/utils/utils';
import PieImg from '../../../../imgs/circle@2x.png';
import dayjs from 'dayjs';

export const getBarChartOption = (electricityList: any[], units: any[]) => {
  return {
    tooltip: {
      trigger: 'axis',
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format('YYYY-MM-DD HH:mm:ss');
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker, seriesType } = item;
          console.log('item', item);
          const value = keepTwoOrLine(data[1]);
          otherStr += `<div style="margin-top:8px;width:200px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${seriesName}</div><div>${value}${
            seriesType === 'line' ? 'kW' : 'kWh'
          }</div></div></div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
      transitionDuration: 0,
      backgroundColor: 'rgba(0,0,0,0.8)',
      borderColor: 'transparent',
      textStyle: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 12,
        fontWeight: 500,
      },
      axisPointer: {
        type: 'shadow', // 显示阴影效果
      },
    },
    grid: { left: 40, right: 30, top: 30, bottom: 20 },
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e).format('HH:mm');
          },
          hideOverlap: true,
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '电量(kWh)',
        position: 'left',
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
      },
      {
        type: 'value',
        name: '功率(kW)',
        position: 'right',
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: '电量',
        type: 'bar',
        data: electricityList.map(a => {
          return [a.ts, a.value];
        }),
        itemStyle: { color: '#16DD8E' },
        yAxisIndex: 0,
      },
      {
        name: '功率',
        type: 'line',
        data: units.map(a => {
          return [a.ts, a.value];
        }),
        showSymbol: false,
        yAxisIndex: 1,
        itemStyle: { color: '#FFCB47' },
        smooth: true,
      },
    ],
  };
};

export const getPieChartOption = (chartData?: any) => {
  return {
    color: ['#52E7FF', '#16DD8E', '#2D8DFF', '#FFCB47', '#854ECA', '#FF9247', '#234ED9', '#FF4D4F'],
    legend: {
      left: 135,
      top: 0,
      orient: 'vertical',
      icon: 'circle',
      itemGap: 8,
      itemHeight: 7,
      itemWidth: 7,
      textStyle: {
        rich: {
          name: {
            fontSize: 14,
            lineHeight: 20,
            width: 240,
            color: 'rgba(255,255,255,0.65)',
          },
          percent: {
            fontSize: 14,
            width: 40,
            color: 'rgba(255,255,255,0.85)',
            align: 'center',
          },
          value: {
            fontSize: 14,
            width: 110,
            color: ' rgba(255,255,255,0.85)',
          },
        },
      },
      formatter: (name: string) => {
        const total = (chartData ?? []).reduce((sum: any, cur: any) => sum + cur.electricity, 0);
        const item = (chartData ?? []).find((item: any) => item.name === name);

        const percent = item ? ((item.electricity / total) * 100).toFixed(1) + '%' : '';

        // 截断 name，最多 15 个字符
        let shortName = name.length > 15 ? name.slice(0, 15) + '...' : name;
        return `{name|${shortName}} {percent|${percent}} {value|${keepTwoOrLine(item?.electricity)}kWh}`;
      },
    },
    graphic: {
      elements: [
        {
          type: 'image',
          style: {
            image: PieImg,
            x: 28,
            y: 39,
            width: 74,
            height: 74,
          },
        },
      ],
    },
    series: [
      {
        type: 'pie',
        // name: '电量(kWh)',
        percentPrecision: 5,
        minAngle: 2,
        padAngle: 1,
        radius: [50, 44],
        left: 15,
        top: 26,
        width: 100,
        height: 100,
        label: {
          show: false,
        },
        data: (chartData ?? []).map((item: any) => ({
          name: item.name,
          value: keepTwoOrLine(item.electricity),
        })),
        showEmptyCircle: false,
      },
      {
        showEmptyCircle: false,
        data: (chartData ?? [])?.map((item: any) => ({
          name: item.name,
          value: keepTwoOrLine(item.electricity),
        })),
        type: 'pie',
        percentPrecision: 5,
        padAngle: 1,
        minAngle: 2,
        // name: '电量(kWh)',
        radius: [48, 60],
        left: 5,
        top: 16,
        width: 120,
        height: 120,
        label: {
          show: false,
        },
        itemStyle: {
          opacity: 0.2,
        },
      },
    ],
  };
};
